import React, { useState } from "react";
import { FOOTER_DATA } from "../data/siteData";
import TermsDialog from "./TermsDialog";

export default function Footer({ onNavigate }) {
  const [termsOpen, setTermsOpen] = useState(false);

  const navMap = {
    "About": "about",
    Services: "software",
    "Case Studies": "portfolio",
    "Technology Solutions": "solutions",
    "Contact": "contact",
  };

  const handleNavClick = (link) => {
    if (link === "Terms & Conditions") {
      setTermsOpen(true);
    } else {
      onNavigate(navMap[link] || "home");
    }
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-col footer-col-brand">
          <div className="footer-brand">
            <img src="/assets/logo.png" alt="" className="footer-logo-img" />
            <span className="footer-logo-text">Rising Sun</span>
          </div>
          <p className="footer-tagline">{FOOTER_DATA.cta}</p>
        </div>

        <div className="footer-col footer-col-hubs">
          <h4 className="footer-col-title">Global Hubs</h4>
          <div className="footer-hub">
            <p className="footer-hub-name">{FOOTER_DATA.hongKong.title}</p>
            <p className="footer-hub-detail">{FOOTER_DATA.hongKong.name}</p>
          </div>
          <div className="footer-hub">
            <p className="footer-hub-name">{FOOTER_DATA.chennai.title}</p>
            <p className="footer-hub-detail">{FOOTER_DATA.chennai.name}</p>
            <p className="footer-hub-detail">{FOOTER_DATA.chennai.address[0]}<br />{FOOTER_DATA.chennai.address[1]}</p>
            <a href={FOOTER_DATA.chennai.location} target="_blank" rel="noopener noreferrer" className="footer-location-link">
              View Location →
            </a>
          </div>
        </div>

        <div className="footer-col footer-col-connect">
          <h4 className="footer-col-title">Connect with Us</h4>
          <a href={`https://mail.google.com/mail/?view=cm&to=${FOOTER_DATA.email}`} target="_blank" rel="noopener noreferrer" className="footer-email">{FOOTER_DATA.email}</a>
          {FOOTER_DATA.phones.map((phone, i) => (
            <a key={i} href={`tel:${phone.replace(/\s/g, '')}`} className="footer-phone">{phone}</a>
          ))}
          <p className="footer-social-label">Connect with Us</p>
          <div className="footer-socials">
            {FOOTER_DATA.socials.map((s, i) => (
              <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label={s.label}>
                {s.label === "LinkedIn" && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                )}
                {s.label === "Instagram" && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                )}
                {s.label === "Email" && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-nav">
        {FOOTER_DATA.links.map((link) => (
          <button
            key={link}
            type="button"
            className="footer-nav-link"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleNavClick(link); }}
            style={link === "Case Studies" ? { display: "none" } : {}}
          >
            {link}
          </button>
        ))}
      </div>

      <div className="footer-bottom">
        <span className="footer-copyright">
          © 2026 Rising Sun Globalized Firm <span className="copyright-sep"> · </span>All rights reserved.
        </span>
      </div>

      <TermsDialog open={termsOpen} onClose={() => setTermsOpen(false)} />
    </footer>
  );
}
